import { ISelectAgentBenefit } from './types';
import { NBSP } from '../../../common/constants/symbols';
import { IconToggleStarOff24, IconActionOpenFolderLine24, IconActionReload24 } from '@cian/ui-kit-design-tokens/icons';

export const SELECT_BEST_AGENT_TITLE = `Подберем лучшего в${NBSP}своём${NBSP}деле`;

export const SELECT_BEST_AGENT_POINTS: ISelectAgentBenefit[] = [
  {
    icon: IconActionOpenFolderLine24,
    title: `С клиентами Сделки работают только наши${NBSP}избранные${NBSP}агенты`,
    description: `Найдём${NBSP}среди них самого подходящего для вас`,
  },
  {
    icon: IconActionReload24,
    title: 'Если вас не устроит — подберём замену',
  },
  {
    icon: IconToggleStarOff24,
    title: `Поиск квартиры для вас всегда будет${NBSP}в${NBSP}приоритете для этого агента`,
  },
];

export const QUALITY_DETAILS_ACTION_TITLE = 'Критерии качества наших агентов';

export const QUALITY_CRITERIA_MODAL_TITLE = 'Критерии качества агентов Циана';

export const QUALITY_CRITERIA_LIST = [
  `Лидеры рынка со${NBSP}стажем${NBSP}более 5 лет`,
  `Есть опыт работы со сложными кейсами`,
  `Знают стратегии торга`,
  `Хорошая репутация на Циане`,
  `Получают отличные отзывы от клиентов`,
  `Закрыли много сделок`,
  `Своевременно отвечают на звонки и${NBSP}сообщения`,
  `Подтвердили свои документы`,
];
